import { Component } from '@angular/core';

import { AuthenticationService } from '../../../auth/authentication.service';
import { UsersnapService } from '../../services';

@Component({
    selector: 'app-usersnap',
    templateUrl: './usersnap.component.html',
    styleUrls: ['./usersnap.component.scss'],
    standalone: false
})
export class UsersnapComponent {
  constructor(private usersnapService: UsersnapService, private authService: AuthenticationService
  ) {
    const currentUser = this.authService.getUserInfo();
    this.usersnapService.initialize({
      user: {
        email: currentUser.username
      },
      custom: {
        name: currentUser.name
      },
      button: {
        position: "rightBottom"
      }
    });
  }

}
